<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h5>Telefony
                    <router-link class="btn btn-circle torre-red" :to="{ name: 'phonesNew' }" title="Dodaj telefon">
                        <i class="material-icons" >
                        add
                        </i>
                    </router-link>
                </h5>
            </div>
        </div>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th class="align-top">
                        <div class="input-group-sm mb-2">
                            <input class="form-control" @keyup="onTextChanged" v-model="form.brandName"/>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <select @change="reloadContent()" class="form-control" v-model="form.phoneStatus">
                                <option v-for="option in statusesOptions" :key="option.id" v-bind:value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                        </div>
                    </th>
                    <th class="align-top" v-if="isAvailablePhonesMode">
                        <div class="input-group-sm align-top mb-2">
                            <label >Data zakupu</label>
                        </div>
                    </th>
                    <th class="align-top" v-if="isSoldPhonesMode">
                        <div class="input-group-sm align-top mb-2">
                            <label >Data sprzedaży</label>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <select @change="reloadContent()" class="form-control" v-model="form.actualStoreId">
                                <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Cena zakupu</label>
                        </div>
                    </th>
                    <th class="align-top" v-if="isAvailablePhonesMode">
                        <div class="input-group-sm align-top mb-2">
                            <label >Cena na półce</label>
                        </div>
                    </th>
                    <th class="align-top" v-if="isSoldPhonesMode">
                        <div class="input-group-sm align-top mb-2">
                            <label >Kwota sprzedaży</label>
                        </div>
                    </th>
                    <th class="align-top" v-if="isSoldPhonesMode">
                        <div class="input-group-sm align-top mb-2">
                            <label >Zysk</label>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Edycja</label>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in phones" :key="item.id">
                    <td>{{ item.phoneName }}</td>
                    <td>{{ statusText() }}</td>
                    <td v-if="isAvailablePhonesMode" >{{ formatDate(item.dateOfPurchase) }}</td>
                    <td v-if="isSoldPhonesMode" >{{ formatDate(item.dateOfSold) }}</td>
                    <td>{{ item.actualStore }}</td>
                    <td>{{ formatPrice(item.paidAmount) }}</td>
                    <td v-if="isAvailablePhonesMode" >{{ formatPrice(item.suggestedPrice) }}</td>
                    <td v-if="isSoldPhonesMode" >{{ formatPrice(item.soldPrice) }}</td>
                    <td v-if="isSoldPhonesMode" >{{ calculateIncome(item) }}</td>
                    <td><router-link :to="{ name: 'phonesEdit', params: { id: item.uuid } }">edytuj</router-link></td>
                </tr>
            </tbody>
        </table>
        <div v-if="showEmptyResult" class="row">
            <div class="col text-center">
                Brak wyników
            </div>
        </div>
        <div class="price-details">
            <span class="bold-text">Suma cen zakupu:</span> {{formatPrice(priceDetails.totalPaidAmount)}} <br/>
            <span class="bold-text">Suma cen na półce:</span> {{formatPrice(priceDetails.totalSuggestedAmount)}}
        </div>
        <common-pagination @paginationClicked="onPaginationClicked"/>
    </div>
</template>
<script>
import alertify from 'alertifyjs';
import un from 'underscore'
import Formatter from "@/service/Formatter"
import PhonesService from "@/components/phones/PhonesService"

const phonesService = new PhonesService()
const formatter = new Formatter()

export default {
    name: "PhonesList",
    data: function() {
        return {
            loading: false,
            phones: [],
            storesOptions: [],
            statusesOptions: [],
            pageable: {
                page: 0
            },
            priceDetails: {
                totalPaidAmount: 0,
                totalSuggestedAmount: 0
            },
            form: {
                brandName: "",
                actualStoreId: 0,
                phoneStatus: "AVAILABLE",
            }
        }
    },
    computed: {
        showEmptyResult() {
            return this.loading === false && this.phones.length === 0
        },
        isAvailablePhonesMode() {
            return this.form.phoneStatus === "AVAILABLE"
        },
        isSoldPhonesMode() {
            return !this.isAvailablePhonesMode
        }
    },
    created() {
        this.loadConfig()
    },
    methods: {
        calculateIncome(item) {
            const income = item.soldPrice - item.paidAmount
            return this.formatPrice(income)
        },
        formatPrice(price) {
            return formatter.price.ZL(price)
        },
        formatDate(phoneDate) {
            return formatter.date.YMD(phoneDate)
        },
        statusText() {
            return this.form.phoneStatus === "AVAILABLE" ? "dostępny" : "sprzedany"
        },
        onTextChanged: un.debounce(function (e) {
            this.pageable.page = 0;
            this.reloadContent();
        }, 300),
        loadConfig() {
            phonesService.loadConfig(this.onConfigLoaded)
        },
        onConfigLoaded(config) {
            this.statusesOptions = config.PhoneStatus
            this.initStoresOptions()
        },
        reloadContent() {
            const requestData = {
                params: this.form,
                pageable: this.pageable
            }
            this.loading = true
            phonesService.search(requestData, this.onSearchSuccess, this.onSearchError)
        },
        onSearchSuccess(data) {
            this.loading = false
            this.phones = data.items
            this.priceDetails.totalPaidAmount = data.priceDetails.totalPaidAmount
            this.priceDetails.totalSuggestedAmount = data.priceDetails.totalSuggestedAmount
            this.$emit('dataChanged', {
                data: data
            });
        },
        onSearchError(err) {
            this.loading = false
            console.log(err)
        },
        initStoresOptions() {
            phonesService.initStores(this.onStoresSuccess)
        },
        onStoresSuccess(data, selectedStore) {
            this.storesOptions = this.initStores(data, selectedStore)
            this.form.actualStoreId = selectedStore.id
            this.reloadContent()
        },
        initStores(options, selectedStore) {
            const finalList = []
            const defaultOption = {
                id: "0",
                name: "wszystkie"
            }
            finalList.push(defaultOption)
            for (var i in options) {
                var item = options[i]
                finalList.push({
                    id: item.id,
                    name: item.name
                })
            }
            return finalList
        },
        onPaginationClicked(payload) {
            var pageToSend = payload.pageToSend;
            this.pageable.page = pageToSend;
            this.reloadContent();
        }
    }
}
</script>
<style scoped>
    .price-details {
        margin-bottom: 10px;
    }
    .bold-text {
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/phones/PhonesList.vue